





































import { Component, Vue } from "vue-property-decorator";
import MemberCard from "@/components/home/MemberCard.vue";
import LoadingOverlay from "@/components/shared/LoadingOverlay.vue";
@Component({ components: { MemberCard, LoadingOverlay } })
export default class InvitedSpeakers extends Vue {
  get invitedSpeakers() {
    return this.$store.getters.getInvitedSpeakers;
  }
}
